import { Button } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { useGlobalStatus } from '../../services/GlobalStatusProvider';

export default function AdminHome() {
  const navigate = useNavigate();
  const {useStyles} = useGlobalStatus();
  const styles = useStyles();

  return (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "3rem" }}>
    <h2 style={{ fontSize: "1.75rem", fontWeight: "600", marginBottom: "2rem" }}>Admin Panel</h2>

    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "350px" }}>
      <Button
        className={styles.buttonPrimary}
        onClick={() => navigate("/sync")}
      >
        🔄 Sync to Projectworks
      </Button>
      
      <Button
        className={styles.buttonPrimary}
        onClick={() => navigate("/weeklytimesheet")}
      >
        🗓️ Weekly Timesheet Status
      </Button>

      <Button
        className={styles.buttonPrimary}
        onClick={() => navigate("/monthlytimesheet")}
      >
        📅 Monthly Timesheet Status
      </Button>

      <Button
        className={styles.buttonPrimary}
        onClick={() => navigate("/monthlytimesheetapprover")}
      >
        📅 Monthly Timesheet External Approval Status
      </Button>
    </div>
  </div>
);

}
